import React from "react";
import Linkify from "linkify-react";
import parse from "html-react-parser";
import { fixAnchorTags } from "../../../util/util";

type CustomLinkfyProps = {
  type?: string;
  str: any;
};

const CustomLinkify: React.FC<CustomLinkfyProps> = ({ type = "div", str }) => {
  const options = {
    target: "_blank",
    nl2br: true,
    defaultProtocol: "https",
  };
  const formattedStr = str.replace(/“/g, '"').replace(/”/g, '"').replace(/‘/g, "'").replace(/’/g, "'");
  return (
    <>
      <Linkify as={type} options={options}>
        {parse(fixAnchorTags(formattedStr))}
      </Linkify>
    </>
  );
};

export default CustomLinkify;
